import { Component, OnInit } from '@angular/core';

// Service
import { ApiService } from '../../shared/service/api.service';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styles: [
  ]
})
export class CareerComponent implements OnInit {

  dataBanner;

  constructor(private apiService: ApiService) {  }

  ngOnInit(): void {
    // Data 
    this.apiService.getDataApi('getSubHeaderByLink/career').subscribe(response => {
      this.dataBanner = response.data;
    });
  }

}
